export default "__VITE_PUBLIC_ASSET__8d7f0146__"